
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34213',
  depVersions: {
  "documents-public-ui": "static-1.34213",
  "client-types": "static-1.454",
  "documents-lib": "static-1.34218",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2019",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4921",
  "highcharts": "static-8.102",
  "hs-promise-utils": "static-1.5485",
  "hs-test-utils": "static-1.7902",
  "hub-http": "static-1.6109",
  "hubspot-dlb": "static-2.1828",
  "HubStyleTokens": "static-2.11340",
  "I18n": "static-7.1598",
  "jasmine-immutable": "static-1.2908",
  "jasmine-runner": "static-1.6360",
  "lodash": "static-1.3",
  "quartz": "static-1.6854",
  "react": "static-7.184",
  "react-dlb": "static-1.76",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.69",
  "react-rhumb": "static-1.16545",
  "reporting-data": "static-1.66964",
  "reporting-testing-lib": "static-1.8897",
  "reporting-visualizations": "static-1.59040",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4660",
  "webpack-env": "static-1.54",
  "atom": "static-1.4961",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2384",
  "classnames": "static-2.10",
  "cssUtils": "static-1.764",
  "customer-data-filters-ui": "static-1.39290",
  "customer-data-objects": "static-1.7545",
  "customer-data-property-utils": "static-1.7974",
  "data-fetching-client": "static-1.9566",
  "enviro": "static-4.425",
  "FireAlarmUi": "static-1.4420",
  "flux-actions": "static-1.323",
  "FormsCommonComponents": "static-1.85539",
  "FormUrlGenerator": "static-2.4610",
  "foundations-components": "static-1.7701",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4034",
  "HubStyle": "static-2.11648",
  "icons": "static-2.637",
  "immutable": "static-2.76",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7050",
  "metrics-js": "static-1.9522",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.386",
  "property-description-translator": "static-1.3745",
  "property-translator": "static-1.5300",
  "quartz-config": "static-1.632",
  "quartz-core": "static-1.6073",
  "quick-fetch": "static-1.3825",
  "raven": "static-3.5808",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5258",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8057",
  "reference-resolvers-lite": "static-1.7980",
  "report-customization-components": "static-1.12801",
  "reporting-enablement": "static-1.22450",
  "reporting-reports": "static-1.66642",
  "reporting-snowflake": "static-1.55582",
  "reporting-ui-components": "static-2.64235",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4534",
  "sales-content-partitioning": "static-1.8828",
  "SalesContentIndexUI": "static-3.9067",
  "sanitize": "static-1.4363",
  "sanitize-text": "static-1.8035",
  "self-service-api": "static-1.10136",
  "SharedI18nStrings": "static-1.181",
  "SharedLegalStrings": "static-1.1643",
  "signup-constants": "static-1.18636",
  "signup-ui-lego-core": "static-1.20646",
  "signup-ui-url-generator": "static-2.7930",
  "styled-components": "static-2.87",
  "StyleGuideUI": "static-3.485",
  "superstore": "static-1.4660",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10882",
  "ui-addon-i18n": "static-1.11038",
  "ui-addon-react-router-dom": "static-1.9435",
  "ui-addon-upgrades": "static-9.17820",
  "ui-asset-management-lib": "static-1.10861",
  "ui-images": "static-2.1124",
  "UIComponents": "static-3.8287",
  "usage-tracker": "static-1.7227",
  "usage-tracker-container": "static-1.7217",
  "usage-tracker-core": "static-1.7077",
  "usage-tracker-public": "static-1.7038",
  "viral-links-lib": "static-1.6929",
  "hs-promise-rejection-tracking": "static-1.5473",
  "raven-hubspot": "static-1.6115",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3316",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3131",
  "quartz-webpack": "static-1.3078",
  "ai-components-ui-library": "static-1.8643",
  "amplitude-session-replay-browser": "static-1.58",
  "foundations-assets": "static-1.4736",
  "foundations-theming": "static-1.4303",
  "quartz-auth": "static-1.529",
  "ui-business-units-lib": "static-1.8930",
  "usage-tracker-session-replay": "static-1.4913",
  "foundations-theming-base": "static-1.3288",
  "HeadJS": "static-2.732",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3013",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4215",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7815",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3499",
  "persist-promise": "static-1.3599",
  "reporting-client-types": "static-1.2427",
  "foundations-components-legacy": "static-1.726",
  "hs-story-utils": "static-1.9320",
  "react-flip-move": "static-1.68",
  "hub-http-shared-msw-handlers": "static-1.9707",
  "hubspotter-http": "static-1.4562",
  "sassPrefix": "static-1.153",
  "conversations-skeleton-state": "static-1.7140",
  "crm-message-bus": "static-1.42655",
  "customer-data-filters-ui-msw-helpers": "static-1.21725",
  "customer-data-objects-ui-components": "static-1.12909",
  "customer-data-reference-ui-components": "static-1.13044",
  "customer-data-ui-utilities": "static-1.9716",
  "framework-builder-read-service-client": "static-1.3918",
  "framework-data-schema-quick-fetch": "static-1.6671",
  "framework-data-schema-resolvers": "static-1.6766",
  "inbound-db-properties-service-client": "static-1.3756",
  "multi-account-reference-resolvers": "static-1.873",
  "onboarding-tours": "static-1.16400",
  "reporting-datasets-permissions-lib": "static-1.13346",
  "ui-addon-teams": "static-1.21393",
  "apollo-stack-hubspot": "static-3.84",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67985",
  "customer-data-properties": "static-1.51137",
  "forms-ai-lib": "static-1.4147",
  "forms-utils-lib": "static-1.12370",
  "foundations-components-test-utils": "static-1.5184",
  "react-dnd-compat": "static-1.4509",
  "react-tinymce": "static-1.54907",
  "tinymce-config": "static-2.54033",
  "ui-gdpr-components": "static-1.10239",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3970",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1493",
  "ui-fonts": "static-1.602",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.816",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.21",
  "quartz-head": "static-1.519",
  "quartz-i18n": "static-1.529",
  "quartz-routing": "static-1.284",
  "quartz-test": "static-1.529",
  "quartz-tracking": "static-1.233",
  "batch-promise": "static-1.1442",
  "external-options-client-types": "static-1.4068",
  "react-colorpicker": "static-2.10100",
  "copilot-toolkit": "static-1.10808",
  "data-quality-ui-library": "static-1.12568",
  "html-to-image": "static-1.52",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6353",
  "reporting-action-components": "static-1.40939",
  "reporting-insights-lib": "static-1.1369",
  "reporting-plugins": "static-1.10122",
  "ui-addon-draggable-compat": "static-2.4145",
  "ui-addon-opt": "static-4.8273",
  "ui-shepherd-react": "static-3.10038",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.25016",
  "hubspot-apollo-client": "static-1.4769",
  "chirp-fetch": "static-1.1772",
  "sales-templates-service-types-lib": "static-1.4076",
  "merchandise-lib": "static-1.261",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5662",
  "salesImages": "static-1.522",
  "ts-schema": "static-1.3988",
  "timezone-utils": "static-2.5135",
  "bender-build-tools": "static-1.3056",
  "chatspot-core": "static-1.20768",
  "bend-plugin-foundations-theming": "static-1.2786",
  "stylex": "static-1.30",
  "hubspotter-http-shared-msw-handlers": "static-1.9705",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3707",
  "crm-pipelines-api-client-types": "static-1.4052",
  "multi-currency-client-types": "static-1.3599",
  "getting-started-shared-tasks": "static-1.18166",
  "growth-data-modal": "static-1.5260",
  "growth-onboarding-confetti": "static-1.2962",
  "growth-onboarding-next-action-utils": "static-1.1573",
  "navigation-components": "static-1.17613",
  "onboarding-tours-client": "static-1.4614",
  "onboarding-tours-utils": "static-1.466",
  "ui-shepherd-tracker": "static-1.7419",
  "ui-universal-auth": "static-1.8822",
  "user-context": "static-1.4990",
  "cms-field-types": "static-1.4700",
  "content-icons-ui": "static-1.2196",
  "integrations-lib": "static-1.15737",
  "calling-global-api": "static-1.64060",
  "calling-internal-common": "static-1.31192",
  "calling-lifecycle-internal": "static-1.65442",
  "calling-lifecycle-messages": "static-1.57736",
  "commerce-products-lib": "static-1.9118",
  "crm-links": "static-1.6166",
  "file-manager-components": "static-1.23255",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.27",
  "inbounddb-objects-service-types": "static-1.4133",
  "meetings-icalendar-utils-lib": "static-1.521",
  "object-builder-ui-client": "static-1.48349",
  "pipeline-validation-client-types": "static-1.3875",
  "property-value-citations": "static-1.1751",
  "pulse": "static-1.425",
  "smart-property-lib": "static-1.6384",
  "tiered-pricing": "static-1.994",
  "ui-addon-iframeable": "static-1.8940",
  "final-form": "static-1.68",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19641",
  "tinymce-themes": "static-1.56003",
  "data-token-picker": "static-1.16211",
  "hub-http-contrib": "static-1.2934",
  "interframe": "static-3.4654",
  "tinymce-data": "static-1.40118",
  "tinymce-plugins": "static-1.57147",
  "ui-addon-sales-email": "static-1.5102",
  "magpie-lib": "static-1.5484",
  "magpie-types": "static-1.4944",
  "simple-logging-lib": "static-1.2942",
  "content-assistance-lib": "static-1.7587",
  "dashboard-lib": "static-1.81040",
  "ExportDialog": "static-6.10281",
  "hubspot-prosemirror": "static-1.17902",
  "hubspot-prosemirror-plugins": "static-1.17894",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8585",
  "campaign-roi-lib": "static-1.8593",
  "feedback-loader": "static-1.29082",
  "apollo-link-hub-http": "static-2.4541",
  "hubspot-apollo-cache": "static-1.228",
  "growth-monetization-service-types": "static-1.4392",
  "nav-client-types": "static-1.2249",
  "purchase-motions-api": "static-1.5665",
  "trials-service-types": "static-1.3793",
  "onboarding-data-sync-lib": "static-1.1775",
  "growth-onboarding-next-action-components": "static-1.1601",
  "user-context-client": "static-1.4502",
  "idb-keyval": "static-1.42",
  "nest": "static-1.112",
  "reactive-lib": "static-1.615",
  "unified-auth-core-lib": "static-1.617",
  "getting-started-shared-tasks-store": "static-1.17284",
  "integrations-error-boundary-lib": "static-1.13152",
  "integrations-tracking-lib": "static-1.5486",
  "native-integrations-shared-strings": "static-1.7677",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10264",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.336",
  "calling-error-reporting": "static-1.31198",
  "shared-worker-versioning": "static-1.10929",
  "calling-usage-tracker": "static-1.6432",
  "voice-sms-access-library": "static-1.552",
  "customer-data-tracking": "static-1.6774",
  "commerce-permissions": "static-1.656",
  "products-iframe-lib": "static-1.7606",
  "products-ui-components-shared-msw-handlers": "static-1.10089",
  "location-customization-utils-lib": "static-1.8872",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.4044",
  "video-components-external": "static-1.10898",
  "video-data-lib": "static-1.34556",
  "directed-graph": "static-1.828",
  "event-emitter": "static-1.839",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.17",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9790",
  "fsm": "static-1.3624",
  "policy-lib": "static-1.6673",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9853",
  "navigation-messaging": "static-1.6940",
  "FileManagerLib": "static-1.38895",
  "NamespacedHubStyle": "static-2.8978",
  "FileManagerCore": "static-1.38754",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12230",
  "layout-dnd-utils": "static-1.11205",
  "react-codemirror": "static-1.10514",
  "ui-addon-emoji-picker": "static-1.9778",
  "ui-brand-identity-lib": "static-1.14704",
  "ui-addon-video-player": "static-1.8587",
  "ui-coaching-tips": "static-1.28213",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8438",
  "payment-link-components": "static-1.23204",
  "EmailSignatureEditor": "static-1.24121",
  "eligibility-engine-service-types": "static-1.3074",
  "InboxConnectUtils": "static-4.14491",
  "universal-page-editor-lib": "static-1.2897",
  "calling-orchestration-schema": "static-1.35329",
  "sales-views-client-types": "static-1.4154",
  "crm-record-cards-service-types": "static-1.3520",
  "content-media-composition-data-lib": "static-1.11854",
  "content-media-compositions": "static-2.15861",
  "media-bridge-lib": "static-1.18731",
  "trellis-story-utils": "static-1.4410",
  "storybook-react": "static-1.31",
  "audio-components": "static-1.5750",
  "FileManagerImages": "static-1.36406",
  "video-components": "static-1.12901",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4422",
  "video-embed": "static-1.35390",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68060",
  "layout-data-lib": "static-1.9530",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6472",
  "commerce-tours-lib": "static-1.5890",
  "growth-onboarding-reliability": "static-1.4977",
  "sales-checkout-service-client": "static-1.3559",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21479",
  "sales-email-signature-service-client": "static-1.3734",
  "social-insights-client-types": "static-1.21728",
  "outpost": "static-1.4086",
  "advanced-menus-core": "static-1.14957",
  "advanced-menus-lib": "static-1.11921",
  "ui-memberships-settings-lib": "static-1.33721",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14956",
  "simple-menus-lib": "static-1.16473"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34213",
  "client-types": "/client-types/static-1.454",
  "documents-lib": "/documents-lib/static-1.34218",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2019",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4921",
  "highcharts": "/highcharts/static-8.102",
  "hs-promise-utils": "/hs-promise-utils/static-1.5485",
  "hs-test-utils": "/hs-test-utils/static-1.7902",
  "hub-http": "/hub-http/static-1.6109",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "HubStyleTokens": "/HubStyleTokens/static-2.11340",
  "I18n": "/I18n/static-7.1598",
  "jasmine-immutable": "/jasmine-immutable/static-1.2908",
  "jasmine-runner": "/jasmine-runner/static-1.6360",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6854",
  "react": "/react/static-7.184",
  "react-dlb": "/react-dlb/static-1.76",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.69",
  "react-rhumb": "/react-rhumb/static-1.16545",
  "reporting-data": "/reporting-data/static-1.66964",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8897",
  "reporting-visualizations": "/reporting-visualizations/static-1.59040",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4660",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4961",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2384",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.764",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39290",
  "customer-data-objects": "/customer-data-objects/static-1.7545",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7974",
  "data-fetching-client": "/data-fetching-client/static-1.9566",
  "enviro": "/enviro/static-4.425",
  "FireAlarmUi": "/FireAlarmUi/static-1.4420",
  "flux-actions": "/flux-actions/static-1.323",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85539",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4610",
  "foundations-components": "/foundations-components/static-1.7701",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "HubStyle": "/HubStyle/static-2.11648",
  "icons": "/icons/static-2.637",
  "immutable": "/immutable/static-2.76",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7050",
  "metrics-js": "/metrics-js/static-1.9522",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.386",
  "property-description-translator": "/property-description-translator/static-1.3745",
  "property-translator": "/property-translator/static-1.5300",
  "quartz-config": "/quartz-config/static-1.632",
  "quartz-core": "/quartz-core/static-1.6073",
  "quick-fetch": "/quick-fetch/static-1.3825",
  "raven": "/raven/static-3.5808",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5258",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8057",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7980",
  "report-customization-components": "/report-customization-components/static-1.12801",
  "reporting-enablement": "/reporting-enablement/static-1.22450",
  "reporting-reports": "/reporting-reports/static-1.66642",
  "reporting-snowflake": "/reporting-snowflake/static-1.55582",
  "reporting-ui-components": "/reporting-ui-components/static-2.64235",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4534",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8828",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9067",
  "sanitize": "/sanitize/static-1.4363",
  "sanitize-text": "/sanitize-text/static-1.8035",
  "self-service-api": "/self-service-api/static-1.10136",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1643",
  "signup-constants": "/signup-constants/static-1.18636",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20646",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7930",
  "styled-components": "/styled-components/static-2.87",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "superstore": "/superstore/static-1.4660",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10882",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11038",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9435",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17820",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10861",
  "ui-images": "/ui-images/static-2.1124",
  "UIComponents": "/UIComponents/static-3.8287",
  "usage-tracker": "/usage-tracker/static-1.7227",
  "usage-tracker-container": "/usage-tracker-container/static-1.7217",
  "usage-tracker-core": "/usage-tracker-core/static-1.7077",
  "usage-tracker-public": "/usage-tracker-public/static-1.7038",
  "viral-links-lib": "/viral-links-lib/static-1.6929",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5473",
  "raven-hubspot": "/raven-hubspot/static-1.6115",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3316",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3131",
  "quartz-webpack": "/quartz-webpack/static-1.3078",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8643",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4736",
  "foundations-theming": "/foundations-theming/static-1.4303",
  "quartz-auth": "/quartz-auth/static-1.529",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8930",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4913",
  "foundations-theming-base": "/foundations-theming-base/static-1.3288",
  "HeadJS": "/HeadJS/static-2.732",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3013",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4215",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7815",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3499",
  "persist-promise": "/persist-promise/static-1.3599",
  "reporting-client-types": "/reporting-client-types/static-1.2427",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.726",
  "hs-story-utils": "/hs-story-utils/static-1.9320",
  "react-flip-move": "/react-flip-move/static-1.68",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9707",
  "hubspotter-http": "/hubspotter-http/static-1.4562",
  "sassPrefix": "/sassPrefix/static-1.153",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7140",
  "crm-message-bus": "/crm-message-bus/static-1.42655",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21725",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12909",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13044",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9716",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3918",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6671",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6766",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3756",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.873",
  "onboarding-tours": "/onboarding-tours/static-1.16400",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13346",
  "ui-addon-teams": "/ui-addon-teams/static-1.21393",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67985",
  "customer-data-properties": "/customer-data-properties/static-1.51137",
  "forms-ai-lib": "/forms-ai-lib/static-1.4147",
  "forms-utils-lib": "/forms-utils-lib/static-1.12370",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5184",
  "react-dnd-compat": "/react-dnd-compat/static-1.4509",
  "react-tinymce": "/react-tinymce/static-1.54907",
  "tinymce-config": "/tinymce-config/static-2.54033",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10239",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3970",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1493",
  "ui-fonts": "/ui-fonts/static-1.602",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.21",
  "quartz-head": "/quartz-head/static-1.519",
  "quartz-i18n": "/quartz-i18n/static-1.529",
  "quartz-routing": "/quartz-routing/static-1.284",
  "quartz-test": "/quartz-test/static-1.529",
  "quartz-tracking": "/quartz-tracking/static-1.233",
  "batch-promise": "/batch-promise/static-1.1442",
  "external-options-client-types": "/external-options-client-types/static-1.4068",
  "react-colorpicker": "/react-colorpicker/static-2.10100",
  "copilot-toolkit": "/copilot-toolkit/static-1.10808",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12568",
  "html-to-image": "/html-to-image/static-1.52",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6353",
  "reporting-action-components": "/reporting-action-components/static-1.40939",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1369",
  "reporting-plugins": "/reporting-plugins/static-1.10122",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4145",
  "ui-addon-opt": "/ui-addon-opt/static-4.8273",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10038",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.25016",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4769",
  "chirp-fetch": "/chirp-fetch/static-1.1772",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4076",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5662",
  "salesImages": "/salesImages/static-1.522",
  "ts-schema": "/ts-schema/static-1.3988",
  "timezone-utils": "/timezone-utils/static-2.5135",
  "bender-build-tools": "/bender-build-tools/static-1.3056",
  "chatspot-core": "/chatspot-core/static-1.20768",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2786",
  "stylex": "/stylex/static-1.30",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9705",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3707",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4052",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3599",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18166",
  "growth-data-modal": "/growth-data-modal/static-1.5260",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2962",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1573",
  "navigation-components": "/navigation-components/static-1.17613",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4614",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.466",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7419",
  "ui-universal-auth": "/ui-universal-auth/static-1.8822",
  "user-context": "/user-context/static-1.4990",
  "cms-field-types": "/cms-field-types/static-1.4700",
  "content-icons-ui": "/content-icons-ui/static-1.2196",
  "integrations-lib": "/integrations-lib/static-1.15737",
  "calling-global-api": "/calling-global-api/static-1.64060",
  "calling-internal-common": "/calling-internal-common/static-1.31192",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65442",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57736",
  "commerce-products-lib": "/commerce-products-lib/static-1.9118",
  "crm-links": "/crm-links/static-1.6166",
  "file-manager-components": "/file-manager-components/static-1.23255",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.27",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4133",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.521",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48349",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3875",
  "property-value-citations": "/property-value-citations/static-1.1751",
  "pulse": "/pulse/static-1.425",
  "smart-property-lib": "/smart-property-lib/static-1.6384",
  "tiered-pricing": "/tiered-pricing/static-1.994",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8940",
  "final-form": "/final-form/static-1.68",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19641",
  "tinymce-themes": "/tinymce-themes/static-1.56003",
  "data-token-picker": "/data-token-picker/static-1.16211",
  "hub-http-contrib": "/hub-http-contrib/static-1.2934",
  "interframe": "/interframe/static-3.4654",
  "tinymce-data": "/tinymce-data/static-1.40118",
  "tinymce-plugins": "/tinymce-plugins/static-1.57147",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5102",
  "magpie-lib": "/magpie-lib/static-1.5484",
  "magpie-types": "/magpie-types/static-1.4944",
  "simple-logging-lib": "/simple-logging-lib/static-1.2942",
  "content-assistance-lib": "/content-assistance-lib/static-1.7587",
  "dashboard-lib": "/dashboard-lib/static-1.81040",
  "ExportDialog": "/ExportDialog/static-6.10281",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17902",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17894",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8585",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8593",
  "feedback-loader": "/feedback-loader/static-1.29082",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4541",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.228",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4392",
  "nav-client-types": "/nav-client-types/static-1.2249",
  "purchase-motions-api": "/purchase-motions-api/static-1.5665",
  "trials-service-types": "/trials-service-types/static-1.3793",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1775",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1601",
  "user-context-client": "/user-context-client/static-1.4502",
  "idb-keyval": "/idb-keyval/static-1.42",
  "nest": "/nest/static-1.112",
  "reactive-lib": "/reactive-lib/static-1.615",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.617",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17284",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13152",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5486",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7677",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10264",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.336",
  "calling-error-reporting": "/calling-error-reporting/static-1.31198",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10929",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6432",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.552",
  "customer-data-tracking": "/customer-data-tracking/static-1.6774",
  "commerce-permissions": "/commerce-permissions/static-1.656",
  "products-iframe-lib": "/products-iframe-lib/static-1.7606",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10089",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8872",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.4044",
  "video-components-external": "/video-components-external/static-1.10898",
  "video-data-lib": "/video-data-lib/static-1.34556",
  "directed-graph": "/directed-graph/static-1.828",
  "event-emitter": "/event-emitter/static-1.839",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.17",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9790",
  "fsm": "/fsm/static-1.3624",
  "policy-lib": "/policy-lib/static-1.6673",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9853",
  "navigation-messaging": "/navigation-messaging/static-1.6940",
  "FileManagerLib": "/FileManagerLib/static-1.38895",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8978",
  "FileManagerCore": "/FileManagerCore/static-1.38754",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12230",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11205",
  "react-codemirror": "/react-codemirror/static-1.10514",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9778",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14704",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8587",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28213",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8438",
  "payment-link-components": "/payment-link-components/static-1.23204",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24121",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3074",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14491",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2897",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35329",
  "sales-views-client-types": "/sales-views-client-types/static-1.4154",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3520",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11854",
  "content-media-compositions": "/content-media-compositions/static-2.15861",
  "media-bridge-lib": "/media-bridge-lib/static-1.18731",
  "trellis-story-utils": "/trellis-story-utils/static-1.4410",
  "storybook-react": "/storybook-react/static-1.31",
  "audio-components": "/audio-components/static-1.5750",
  "FileManagerImages": "/FileManagerImages/static-1.36406",
  "video-components": "/video-components/static-1.12901",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4422",
  "video-embed": "/video-embed/static-1.35390",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68060",
  "layout-data-lib": "/layout-data-lib/static-1.9530",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6472",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5890",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4977",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3559",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21479",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3734",
  "social-insights-client-types": "/social-insights-client-types/static-1.21728",
  "outpost": "/outpost/static-1.4086",
  "advanced-menus-core": "/advanced-menus-core/static-1.14957",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11921",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33721",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14956",
  "simple-menus-lib": "/simple-menus-lib/static-1.16473"
}
};
